import React from 'react';
import PropTypes from 'prop-types';
import IconCLose from './IconClose';

class Icon extends React.Component {
  static propTypes = {
    type: PropTypes.string,
  };
  static defaultProps = {
    type: '',
  };

  // type="close"
  // onClick={() => this.handleChange('clear')}
  // style={{ cursor: 'pointer' }}
  getIcon = type => {
    switch (type) {
      case 'close':
        return <IconCLose {...this.props} />;
      default:
        return <div />;
    }
  };

  render() {
    const { type, ...otherProps } = this.props;
    return (
      <span className="ant-input-suffix" {...otherProps}>
        {this.getIcon(type)}
      </span>
    );
  }
}

export default Icon;



// WEBPACK FOOTER //
// ./src/shared/components/AntdComponents/Icon/Icon.js